import {makeAutoObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {DateTimeModel} from '../Date/DateTime.model';

export class CourseRestart {
  constructor(
    public date: DateTimeModel,
    private _reason?: Nullable<string>,
  ) {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  get reason() {
    return this._reason ?? '';
  }

  get renderDate() {
    return this.date.format('ll');
  }
}
